import { Controller } from "stimulus"

// Quantity counter with increment/decrement buttons.
//
// Usage:
//   .d-flex.align-items-center.gap-2{"data-controller" => "qty-counter", "data-qty-counter-min-value" => "0", "data-qty-counter-max-value" => "100", "data-qty-counter-step-value" => "1"}
//     %button{"data-action" => "click->qty-counter#decrement"} -
//     %input{"data-qty-counter-target" => "input", type: "text", value: "1"}
//     %button{"data-action" => "click->qty-counter#increment"} +
//
export default class extends Controller {
  static targets = ["input"]
  // { type, default } shorthand throws on this app's Stimulus version and aborts controller loading site-wide -- bare types + manual fallback instead
  static values = {
    min: Number,
    max: Number,
    step: Number
  }

  increment() {
    var current = this.currentValue()
    var step = this.hasStepValue ? this.stepValue : 1
    var max = this.hasMaxValue ? this.maxValue : 999
    var next = current + step
    if (next <= max) {
      this.inputTarget.value = next
    }
  }

  decrement() {
    var current = this.currentValue()
    var step = this.hasStepValue ? this.stepValue : 1
    var min = this.hasMinValue ? this.minValue : 0
    var next = current - step
    if (next >= min) {
      this.inputTarget.value = next
    }
  }

  currentValue() {
    return parseInt(this.inputTarget.value, 10) || 0
  }
}
